<script>
import { Modal } from "bootstrap";
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
export default {
 components: {Layout, PageHeader},
  page: {
    meta: [
      {
        name: "description",
      },
    ],
  },
  data() {
    return {
    payModal: null,
    perPage: 5,
    rows: 0,
    currentPage: 1,
    selectTrainer: "",
    pay_amount: 0,
    invoices: [],
    previous_payable: 0,
    prepayment: 0,
    studentTotal: 0,
    accountform: [],
    account: '',
    accountts: []
    };
  },
  computed: {
    totalPaymentMadeAmount(){
      return this.payment_made_data.payment_method == 'cashBank' ? parseFloat(this.payment_made_data.cash_amount) + parseFloat(this.payment_made_data.bank_amount) : parseFloat(this.payment_made_data.pay_amount)
    }
  },
  methods: {
    selectCustomer() {
      console.log(this.selectTrainer);
      this.http
        .post("billing-invoices/details", {
          limit: this.perPage,
          page: this.currentPage,
        })
        .then((res) => {
            this.invoices = res.data.invoices !== 'undefined' ? res.data.invoices : [];
            this.previous_payable = Math.abs(parseFloat(res.data.previous_receivable))
            this.prepayment = Math.abs(parseFloat(res.data.unearned_revenue))
            this.studentTotal = res.data.totInvoices;
            this.rows = res.data.totInvoices
        });
    },
    payInvoices() {
      let obj ={
        accounts: this.accountform,
      }
      this.http
        .post("billing-invoices/payment-made", obj)
        .then((res) => {
          if (res.status) {
            this.addPayAccounts = [{}];
            this.payModal.hide();
            this.selectCustomer()
          }
        });
   
   },
    openPayModal(){
      this.payModal.show()
      this.accountform = [{value: 0, account: ''}]
    },
    AddAccount() {
        this.accountform.push({value: 0, account: ''})
    },
    SearchAccounts(event) {
        const qry = event.query.toLowerCase()
        this.accountts = qry ? this.accountContent.filter(item => item.name_en.toLowerCase().includes(qry)) : [...this.accountContent]
    },
    GetAccounts() {
        this.http.get('billing-invoices/cash_accounts').then((res) => {
            this.accountContent = res.data
        })
    },
  },
  mounted() {
    this.centerId = localStorage["centerID"];
    this.GetAccounts()
    this.selectCustomer()
    this.payModal = new Modal("#payModal");
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.billing.subItems.reconciliation')"
    />
    <div
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      class="form-group row mb-3"
    >

      <!-- <BRow>
        
        <BCol lg="3" md="3" sm="12">
          <div style="height: 50px;">
            <label
              class="col-md-2.5 col-form-label"
              for="userName"
              style="font-size: 16px; font-weight: bolder"
              >{{ $t("billing_invoices.payment.searchtrainer") }}</label
              >
          </div>
          <AutoComplete v-model="selectTrainer"
            :complete-on-focus="true"
            :suggestions="trainers"
            @complete="Searchtrainer"
            optionLabel="name"
            style="
              color: #333 !important;
              border-radius: 10px !important;
              width: 100%;
            "
          />
        </BCol>
        <BCol lg="5" sm="12" md="5">
          <div style="height: 50px;"></div>
          <button 
            @click="selectCustomer()"
            type="button"
            :disabled="!selectTrainer"
            class="btn btn-primary mt-1"
          >
            {{ $t("popups.search") }}
          </button>
        </BCol>
      </BRow> -->
    </div>

    <div class="row" v-if="invoices.length > 0">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead>
                <tr
                  class="text-light"
                  style="background-color: #2a3042 !important"
                >
                  <!-- <th scope="col">{{ $t("billing_invoices.payment.id") }}</th> -->
                  <th scope="col">{{ $t('billing_invoices.payment.name') }}</th>
                  <th scope="col">{{ $t('billing_invoices.payment.total_invoice') }}</th>
                  <th scope="col">{{ $t('billing_invoices.payment.total_payable') }}</th>
                  <th scope="col">{{ $t('billing_invoices.payment.total_account') }}</th>
                  <!-- <th scope="col">{{ $t("billing_invoices.payment.phone") }}</th> -->
                  <th scope="col">{{ $t('billing_invoices.payment.created') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <!-- <td>{{ selectTrainer?.id }}</td> -->
                  <td>
                    {{ $t("billing_invoices.payment.elect")  }}
                  </td>
                  <td>
                    {{
                      parseFloat(
                        studentTotal ? studentTotal : 0
                      ).toLocaleString()
                    }}
                  </td>
                  <td
                    :style="{
                      color:
                        parseFloat(previous_payable) < 0
                          ? '#26d526'
                          : parseFloat(previous_payable) > 0
                          ? 'green'
                          : '',
                    }"
                  >
                    {{ parseFloat(previous_payable).toLocaleString() }}
                  </td>
                  <td
                    :style="{
                      color:
                        parseFloat(prepayment) < 0
                          ? '#26d526'
                          : parseFloat(prepayment) > 0
                          ? 'red'
                          : '',
                    }"
                  >
                    {{ parseFloat(prepayment).toLocaleString() }}
                  </td>
                  <td>
                    {{
                      " - "
                    }}
                  </td>
                  <!-- <td>{{ selectTrainer?.tel }}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-between">
            <div></div>
            <div>
              <button
                v-if="invoices.length > 0"
                @click="openPayModal()"
                class="btn btn-primary"
              >
               pay Invoice
              </button>
              <button
                v-if="invoices.length <= 0"
                @click="openPayModal()"
                class="btn btn-primary"
              >
                pay Invoice
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="invoices.length > 0">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead>
                <tr
                  class="text-light"
                  style="background-color: #2a3042 !important"
                >
                  <th scope="col">#</th>
                  <!-- <th scope="col">{{ $t("payment_made.name") }}</th> -->
                  <!-- <th scope="col">{{ $t("payment_made.type") }}</th> -->
                  <th scope="col">{{ $t('billing_invoices.payment.invoice_amount') }}</th>
                  <th scope="col">{{ $t('billing_invoices.payment.paid') }}</th>
                  <th scope="col">{{ $t('billing_invoices.payment.remaining') }}</th>
                  <th scope="col">{{ $t('billing_invoices.payment.created') }}</th>
                  <th scope="col">{{ $t('billing_invoices.payment.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="app in invoices" :key="app" class="">
                  <td>#{{ app.id }}</td>
                  <td>
                    {{ parseFloat(app?.total_amount).toLocaleString() }}
                  </td>
                  <td>
                    {{
                      parseFloat(
                        app?.paid_amount ? app?.paid_amount : 0
                      ).toLocaleString()
                    }}
                  </td>
                  <td>
                    {{
                      (
                        parseFloat(app?.total_amount) -
                        parseFloat(app?.paid_amount ? app?.paid_amount : 0)
                      ).toLocaleString()
                    }}
                  </td>
                  <td>
                    {{
                      app?.created
                        ? new Date(app?.created).toLocaleString("en-GB", {
                            hour12: true,
                          })
                        : " - "
                    }}
                  </td>
                    <td :style="{ color: parseFloat(app?.total_amount) == parseFloat(app?.paid_amount) ? 'green' : 'red' }">
                    {{
                      parseFloat(app?.total_amount) ==
                      parseFloat(app?.paid_amount)
                      ? $i18n.locale == "ar"
                        ? "تم الدفع"
                        : "Paid"
                      : $i18n.locale == "ar"
                      ? "لم يتم الدفع"
                      : "Unpaid"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end my-3">
        <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage" size="sm"></b-pagination>
      </div>
    </div>
    <!-- end  table -->

    <!--   Sale  Pagination     -->
    

    <!--Start Pay Modal-->
    <div
      class="modal fade"
      id="payModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form @submit.prevent="payInvoices()">
            <div class="modal-header">
              <div class="d-flex justify-content-around">
                <h5 class="modal-title w-100" id="exampleModalLabel">{{$t('billing_invoices.payment.title')}}</h5>
              </div>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="margin: 0"
              ></button>
            </div>
            <div class="modal-body">
              <div class="">
                <div class="mt-3">
                  <div>
                    <div class="text-end">
                        <BButton variant="dark" @mouseenter="ishhover=true" @mouseleave="ishhover=false" @click="AddAccount">
                            <i class="bx bx-plus-medical" v-if="!ishhover"></i>
                            <span v-else>{{ $t('billing_invoices.payment.addaccount') }}</span>
                        </BButton>
                    </div>
                    <div>
                        <BRow class="my-5" v-for="(item, indx) in accountform" :key="indx">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex gap-4">
                                    <lable class="text-primary">{{ $t('billing_invoices.payment.paymenttype') }}</lable>
                                    <AutoComplete :complete-on-focus="true" v-model="item.account" :suggestions="accountts" optionLabel="name_en" @complete="SearchAccounts" appendTo="self"/>
                                    <currency-input v-model="item.value" :min="0"></currency-input>
                                    <BButton class="danger" @click="this.accountform.splice(indx, 1)"><i class="bx bx-trash"></i></BButton>
                                </div>
                            </div>
                        </BRow>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div
              class="modal-footer"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            >
              <button
                type="submit"
                class="btn btn-primary"
              >
                {{ $t("popups.pay") }}
              </button>
              <button
                data-bs-dismiss="modal"
                type="button"
                class="btn btn-danger"
              >
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </Layout>
    <!--End Pay Modal-->
</template>
